import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";

interface ScreenReaderTextProps {
  id?: string;
  text: string | string[];
  ariaLive?: "polite" | "assertive" | "off";
  ariaAtomic?: boolean;
  role?: React.HTMLAttributes<HTMLElement>["role"];
  announnceDelay?: number;
}
const acc_space = "..";
/**
 * Component for text that is only accessible to screen readers
 */
const ScreenReaderText: React.FC<ScreenReaderTextProps> = ({
  id, 
  text,
  role = "alert",
  ariaLive = "polite",
  ariaAtomic = true,
  announnceDelay = 50,
}) => {
  const [canAnnounce, setCanAnnounce] = useState(false);
  const uniqueId = new Date().getTime();

  const createAnnounceContent = (text: string | string[]) => {
    if (Array.isArray(text)) {
      return (
        <span key={`ScreenReaderText-span-${uniqueId}`}>
          {text.map((item, index) => (
            <span key={`${item}-${index}-announce-${uniqueId}`}>{item + acc_space.repeat(5)}</span>
          ))}
        </span>

      );
    }
    return text;
  }
  const announceContent = createAnnounceContent(text);
  useEffect(() => {
    const timer = setTimeout(() => {
      setCanAnnounce(true);
    }, announnceDelay);
    return () => clearTimeout(timer);
  }, [announnceDelay]);

  return (
    <div id={id} key={`ScreenReaderText-div-${uniqueId}`} className={styles.srOnly} aria-live={ariaLive} aria-atomic={ariaAtomic} role={role}>
      {canAnnounce ? announceContent : null}
    </div>
  );
};

export default ScreenReaderText;
